<template>
  <div class="video-container" data-aos="zoom-in">
    <video autoplay loop muted>
      <source src="/images/video.mp4" type="video/mp4" />
    </video>
    <div class="overlay-text">
      <h2 class="overlay-heading">Your style is important part of your mood</h2>
      <p class="overlay-article">Let’s make your mood is good together</p>
      <router-link :to="{ name: 'AllItems' }">
        <store-button class="store-btn">Go to store</store-button>
      </router-link>
    </div>
  </div>
</template>

<style scoped>
.video-container {
  position: relative;
  width: 100vw;
}

video {
  width: 100%;
  height: 80rem;
  object-fit: cover;
}

.overlay-text {
  display: flex;
  flex-direction: column;
  gap: 60px;

  position: absolute;
  top: 50%;
  left: 5%;
  transform: translateY(-50%);
  width: min(60%, 700px);
  text-align: left;
}

.overlay-heading {
  color: #fff;
  font-family: "Mabry Pro";
  font-size: 3.6rem;
  font-weight: 500;
  max-width: 40rem;
}

.overlay-article {
  color: #fff;
  font-family: "Mabry Pro";
  font-size: 2.8rem;
  font-weight: 300;
  max-width: 28rem;
  margin-bottom: 50px;
}

.store-btn {
  max-width: 180px;
  flex-shrink: 0;
}
</style>